import React, { useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/nb';
import { getValidLanguageTagForMoment } from 'commons/src/commonFunctions';
import { Store } from '../../reducers';

interface StateProps {
    organizationName?: string;
    organizationLogo?: string;
    segmentName?: string;
    timeStamp: number;
    serialNumber: string | undefined;
}

export type Props = StateProps;

export const PageHeader = (props: Props) => {
    const { organizationName, organizationLogo, segmentName, serialNumber, timeStamp } = props;
    const { t: txt } = useTranslation();
    const interval = useRef<null | NodeJS.Timeout>(null);
    const syncedTimeAgo = () => {
        const language = getValidLanguageTagForMoment();
        return moment.unix(timeStamp).local().locale(language).fromNow();
    };
    const [lastSynced, setLastSynced] = useState(syncedTimeAgo());

    useEffect(() => {
        // make timer displaying when last synced update every minute.
        interval.current = setInterval(() => {
            setLastSynced(syncedTimeAgo());
        }, 60000);
        return () => {
            if (interval && interval.current) clearInterval(interval.current);
        };
    }, []);

    useEffect(() => {
        setLastSynced(syncedTimeAgo());
    }, [timeStamp]);

    return (
        <div className="public-page-header">
            <div className="device-header">
                {organizationLogo ? (
                    <img
                        className="info__organization-logo"
                        src={organizationLogo}
                        alt={txt('OrganizationProfile.LogoImage')}
                    />
                ) : (
                    <div className="info__organization-name">{organizationName}</div>
                )}
                <div>
                    <div className="addtl-info__section">
                        <div className="info__room-name">{segmentName}</div>
                        <div className="info__text sync-header">{txt('PublicIAQDashboard.SyncHeader')}</div>
                    </div>
                    <div className="addtl-info__section">
                        <div className="info__text">
                            {txt('PublicIAQDashboard.SerialNumber', { serialNumber: serialNumber || '' })}
                        </div>
                        <div className="info__text">{lastSynced}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (store: Store): StateProps => {
    const {
        publicDeviceData: { organizationName, organizationLogo, segmentName, serialNumber },
        publicDeviceSensorData: { timeStamp },
    } = store;
    return {
        organizationName,
        organizationLogo,
        segmentName,
        timeStamp,
        serialNumber,
    };
};

export default connect(mapStateToProps)(PageHeader);
